// extracted by mini-css-extract-plugin
export default {"optionIcon":"SavedFiltersSelect_optionIcon__bn2ef","filterControlButton":"SavedFiltersSelect_filterControlButton__-yKim"};